import { EcommerceAPI } from "../Client";

const getDashboardQuery = (payload = {}) => {
  const params = new URLSearchParams({
    year: String(Number(payload.year) || ""),
    category: String(Number(payload.category) || 0),
    month: String(Number(payload.month)),
    day: String(Number(payload.day)),
  });

  return `/dashboard?${params.toString()}`;
};

export const getDashboardDataAPI = (payload) => {
  return EcommerceAPI.get(getDashboardQuery(payload))
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
export const getLastOneYearDashboardDataAPI = (payload) => {
  return EcommerceAPI.get(getDashboardQuery(payload))
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
export const getLastTwoYearDashboardDataAPI = (payload) => {
  return EcommerceAPI.get(getDashboardQuery(payload))
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDashboardFilterYearAPI = () => {
  return EcommerceAPI.get("/dashboard/filter-year")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDashboardSellerDataAPI = () => {
  return EcommerceAPI.get("/dashboard/seller")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getDashboardAdminDataAPI = () => {
  return EcommerceAPI.get("/dashboard/admin")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};
